import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@material-ui/icons/IndeterminateCheckBoxOutlined";
import { useParams } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";

function EditSubjectForm() {
  const classes = useStyles();

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const [sections, setSections] = useState([{ name: "" }]);

  // const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState([]);

  const { rowId } = useParams();

  const handleClose = () => {
    navigate("/admin/section");
  };

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const handleAddLink = () => {
    setSections((prevLinks) => [...prevLinks, { name: "" }]);
  };

  const handleRemoveLink = (index) => {
    setSections((prevLinks) => {
      const updatedLinks = [...prevLinks];
      updatedLinks.splice(index, 1);
      return updatedLinks;
    });
  };

  const handleCourceChange = (event, newValue) => {
    setSelectedCourse(newValue.id);
  };

  const handleBatchChange = (event, newValue) => {
    setSelectedBatch(newValue.id);
  };

  const handleSubjectChange = (event, newValue) => {
    setSelectedSubject(newValue.id);
  };

  const handleFormSubmit = () => {
    if (!selectedSubject) {
      toast.warn("Please enter a Subject name.");
      return;
    }

    if (!sections.trim()) {
      toast.warn("Please enter a section name.");
      return;
    }

    const data = {
      subjects_section: {
        id: rowId,
        subjects_id: selectedSubject,
        section_name: sections,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject_section/update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTimeout(() => {
          navigate("/admin/section");
        }, 2000);
        toast.success("Section update successfully");
      })
      .catch((error) => {
        toast.error("Section is not update");
      });
  };

  // useEffect(() => {
  //   const fetchCourses = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/course/all/active`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${decryptedToken}`,
  //           },
  //         }
  //       );

  //       // Ensure that the API response contains the 'batch' property
  //       if (response.data && response.data.courses) {
  //         setCourses(response.data.courses);
  //       } else {
  //         console.error("Invalid API response format:", response);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching courses:", error);
  //     }
  //   };

  //   fetchCourses();
  // }, [decryptedToken]);


  const fetchSubjects = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (response.data && response.data.subjects) {
        setSubjects(response.data.subjects);
      } else {
        console.error("Invalid API response format:", response);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  useEffect(() => {
    if (rowId) {
      fetchDataFromAPI(rowId);
    }
  }, [rowId]);

  const fetchDataFromAPI = async (rowId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject_section/${rowId}`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });

      if (response.status === 200) {
        const data = response.data.subjects_section;

        console.log("data", data);
        setSections(data.section_name);
        setSelectedCourse(data.course.id);
        setSelectedBatch(data.batch.id);
        setSelectedSubject(data.subject.id);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error fetching data from the API:", error);
    }
  };

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Section Details
              </Typography>

              <div
                            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                          >
            <FormLabel
                              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                            >
                              Subject <span className={classes.textcolorred}>*</span>
                            </FormLabel>
                            <Autocomplete
                              id="state-autocomplete"
                              options={subjects || []}
                              // value={selectedSubject}
                              value={
                                subjects.find((sub) => sub.id === selectedSubject) || ""
                              }
                              classes={{ inputRoot: classes.inputRoot }}
                              onChange={handleSubjectChange}
                              disableClearable
                              getOptionLabel={(option) => option?.subject_name || ""}
                              autoHighlight
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select Here"
                                  variant="outlined"
                                />
                              )}
                              selectOnFocus
                              openOnFocus
                            />
                          </div>
                          
                          <div
                            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                          >
                            {/* <FormLabel
                              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                            >
                              Course <span className={classes.textcolorred}>*</span>
                            </FormLabel>
            
                            <Autocomplete
                              id="tags-standard"
                              options={courses}
                              getOptionLabel={(option) => option.course_name}
                              value={courses.find((sub) => sub.id === selectedCourse) || ""}
                              onChange={handleCourceChange}
                              disableClearable
                              forcePopupIcon={false}
                              renderInput={(params) => (
                                <TextField
                                  name="section"
                                  type="text"
                                  variant="outlined"
                                  placeholder="Type to pick course..."
                                  {...params}
                                />
                              )}
                            /> */}
                          </div>
            
                          <div
                            className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
                          >
                            {/* <FormLabel
                              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                            >
                              Batch <span className={classes.textcolorred}>*</span>
                            </FormLabel>
                            <Autocomplete
                              id="state-autocomplete"
                              options={batches || []}
                              // value={selectedSubject}
                              value={batches.find((sub) => sub.id === selectedBatch) || ""}
                              classes={{ inputRoot: classes.inputRoot }}
                              onChange={handleBatchChange}
                              disableClearable
                              getOptionLabel={(option) => option?.batch_name || ""}
                              autoHighlight
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Select Here"
                                  variant="outlined"
                                />
                              )}
                              selectOnFocus
                              openOnFocus
                            /> */}
                          </div>


            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Section Name <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <TextField
                  onChange={(e) => {
                    setSections(e.target.value);
                  }}
                  value={sections}
                  type="text"
                  variant="outlined"
                  required
                  placeholder="Enter Name"
                  InputProps={{}}
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24}`}
              ></div>
            </div>
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default EditSubjectForm;
